import React, { useEffect } from "react";
import styled from "styled-components";

export const FiltersList = styled.ul`
    display: flex;
    list-style: none;
    margin-left: auto;
    margin-bottom: 0;
    padding-left: 0;

    li {
        cursor: pointer;
        margin-left: 1rem;
        position: relative;
    }
`;

export const FilterItem = styled.li<{ muted: boolean }>`
    transition: opacity 0.3s ease-out;
    opacity: ${props => props.muted ? 0.5 : 1};
`;

const ContextMenu = styled.div`
    background: var(--page-bg);
    border: 1px solid var(--text-primary);
    display: flex;
    position: absolute;
    flex-direction: column;
    padding: 0.5rem 0;
    right: 0;
    top: 100%;
    white-space: nowrap;
    z-index: 10;
`;

const MenuOption = styled.span<{ active?: boolean }>`
    cursor: pointer;
    display: block;
    font-weight: ${props => props.active ? 'bold' : 'normal'};
    padding: 0.25rem 1rem;
`;

interface Props {
    setShowSearch: React.Dispatch<React.SetStateAction<boolean>>;
    setShowCinemaFilter: React.Dispatch<React.SetStateAction<boolean>>;
    setSortedBy: React.Dispatch<React.SetStateAction<'distance' | 'name' | null>>;
    showSearch: boolean;
    showSort: boolean;
    sortedBy: 'distance' | 'name' | null;
}

const ShowtimesBlockCinemaFilters = (props: Props) => {
    const { setShowSearch, showSearch, setShowCinemaFilter, setSortedBy } = props;
    const [showSortMenu, setShowSortMenu] = React.useState(false);

    useEffect(() => {
        function handleClickOutside(e: MouseEvent) {
            const target = e.target as HTMLElement;
            if (!target.closest('.context-menu')) {
                setShowSortMenu(false);
            }
        }

        if (showSortMenu) {
            document.addEventListener('click', handleClickOutside);
        } else {
            document.removeEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showSortMenu]);

    return <>
        <FiltersList>
            <FilterItem muted={showSortMenu}><em className='fal fa-search' onClick={() => setShowSearch(!showSearch)}></em></FilterItem>
            <FilterItem muted={showSearch || showSortMenu}><em className='fal fa-filter' onClick={() => setShowCinemaFilter(true)}></em></FilterItem>
            {props.showSort && <FilterItem muted={showSearch}><em className='fal fa-arrow-down-arrow-up' onClick={() => setShowSortMenu(!showSortMenu)}></em>
                {showSortMenu && (
                    <ContextMenu className="context-menu">
                        <MenuOption active={'distance' === props.sortedBy} onClick={() => setSortedBy('distance')}>Ordenar por distancia</MenuOption>
                        <MenuOption active={'name' === props.sortedBy} onClick={() => setSortedBy('name')}>Ordenar alfabéticamente</MenuOption>
                    </ContextMenu>
                )}
            </FilterItem>}
        </FiltersList>
    </>;
}

export default ShowtimesBlockCinemaFilters;